import { render, staticRenderFns } from "./Fillinthenegativenumber.vue?vue&type=template&id=06f3b2a0&"
import script from "./Fillinthenegativenumber.vue?vue&type=script&lang=js&"
export * from "./Fillinthenegativenumber.vue?vue&type=script&lang=js&"
import style0 from "./Fillinthenegativenumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports